<template>
  <div
    class="flex justify-between items-center border border-gray-300 rounded bg-white p-4 mt-3"
  >
    <p class="text-sm">
      <b class="text-primary">NOTE</b>: Your plan will be cancelled at the end
      of the month!
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
